export default "__VITE_ASSET__5b425d62__"